(() => {
  const CART_ATTRIBUTE = 'Términos y condiciones';
  const ACCEPTED_VALUE = 'Aceptados por el cliente antes de pagar';

  // Estado unico compartido por pagina de carrito, notificacion y drawer.
  let accepted = false;

  const allCheckboxes = () => Array.from(document.querySelectorAll('[data-owl-terms-ack]'));

  const checkoutButtonFor = (checkbox) => {
    const scope = checkbox.closest('.cart__ctas, .cart-notification__links, .drawer__footer');
    return scope ? scope.querySelector('button[name="checkout"]') : null;
  };

  // Idempotente: solo escribe si el valor cambia, para no disparar mutaciones en bucle
  // con el MutationObserver del drawer.
  const syncUI = () => {
    allCheckboxes().forEach((checkbox) => {
      if (checkbox.checked !== accepted) checkbox.checked = accepted;
      const button = checkoutButtonFor(checkbox);
      if (button && button.disabled !== !accepted) button.disabled = !accepted;
    });
  };

  // Las peticiones se encadenan para que un marcar/desmarcar rápido no llegue desordenado,
  // y se reintenta una vez si el servidor responde con error (p. ej. 503 intermitente).
  const postAttributes = (attributes) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });

  let saveQueue = Promise.resolve();
  const saveCartAttribute = (value) => {
    const attributes = {};
    attributes[CART_ATTRIBUTE] = value ? ACCEPTED_VALUE : '';
    saveQueue = saveQueue
      .then(() => postAttributes(attributes))
      .then((response) => {
        if (response.ok) return response;
        return new Promise((resolve) => setTimeout(resolve, 800)).then(() => postAttributes(attributes));
      })
      .catch(() => {});
  };

  // Delegacion en document: sobrevive a los re-render del drawer al agregar productos
  // (el HTML interno de <cart-drawer> se reemplaza completo y los listeners directos se pierden).
  document.addEventListener('change', (event) => {
    if (!event.target || !event.target.matches || !event.target.matches('[data-owl-terms-ack]')) return;
    accepted = event.target.checked;
    syncUI();
    saveCartAttribute(accepted);
  });

  // Guard en fase de captura: si un re-render dejo el boton habilitado por un instante,
  // el checkout sin aceptar los TyC se bloquea igual.
  document.addEventListener(
    'click',
    (event) => {
      if (accepted || !event.target || !event.target.closest) return;
      const button = event.target.closest('button[name="checkout"]');
      if (!button) return;
      const scope = button.closest('.cart__ctas, .cart-notification__links, .drawer__footer');
      if (scope && scope.querySelector('[data-owl-terms-ack]')) {
        event.preventDefault();
        event.stopPropagation();
        syncUI();
      }
    },
    true
  );

  // Re-aplicar el estado cada vez que el drawer se re-renderiza.
  const drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(() => syncUI()).observe(drawer, { childList: true, subtree: true });
  }

  // Estado inicial: SIEMPRE desmarcado (2026-07-11 — antes se restauraba desde el atributo del
  // carrito y la casilla aparecia pre-marcada en visitas siguientes). Si quedo un atributo de
  // aceptacion viejo, se limpia: el pedido solo debe llevarlo si se marco en esta compra.
  syncUI();
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => {
      const attributes = cart.attributes || {};
      if (attributes[CART_ATTRIBUTE]) saveCartAttribute(false);
    })
    .catch(() => {});
})();
